import React from 'react';
import {
  MdLocalFlorist,
  MdReceiptLong,
  MdPerson,
  MdLocalShipping,
  MdBadge,
  MdAccountBalanceWallet,
} from 'react-icons/md';
import { CategoryType } from './categoriesList';

// Icon + nhãn cho từng nhóm để hiển thị tìm kiếm chuyên nghiệp hơn.
export const CATEGORY_ICON: Record<CategoryType, React.ReactNode> = {
  product: <MdLocalFlorist />,
  order: <MdReceiptLong />,
  customer: <MdPerson />,
  supplier: <MdLocalShipping />,
  employee: <MdBadge />,
  ledger: <MdAccountBalanceWallet />,
};

export const CATEGORY_LABEL: Record<CategoryType, string> = {
  product: 'Sản phẩm',
  order: 'Đơn hàng',
  customer: 'Khách hàng',
  supplier: 'Nhà cung cấp',
  employee: 'Nhân viên',
  ledger: 'Sổ cái',
};
